<template>
  <div class="container" id="myChartWrap">
    <div id="lineId"></div>
  </div>
</template>

<script>
import echarts from "echarts/lib/echarts"

require("echarts/lib/chart/line")
require("echarts/lib/chart/bar")

require("echarts/lib/component/toolbox")
require("echarts/lib/component/tooltip")
require("echarts/lib/component/legend")

export default {
  name: 'Charts',
  props: {
    lineData: {
      type: Object,
      required: true,
      default() {
        return {
          series1: [],
          series2: []
        }
      }
    }
  },
  data() {
    return {
      data: {
        series1: [],
        series2: []
      }
    }
  },
  computed: {
    myChart() {
      return echarts.init(document.getElementById("lineId"))
    }
  },
  mounted() {
    this.setSize()
    window.onresize = () => {
      this.setSize()
    }
  },
  destroyed() {
    window.onresize = null
  },
  methods: {
    setSize() {
      let wrapWidth = document.getElementById("myChartWrap").clientWidth
      let wrapHeight = document.getElementById("myChartWrap").clientHeight
      this.myChart.resize({
        width: wrapWidth,
        height: wrapHeight
      })
    },
    renderChart() {
      const _this = this
      const options = {
        legend: {
          orient: 'vertical',
          left: '10%',
          top: '10%',
          icon: 'circle',
        },
        color:['#12a5ed','red'],
        tooltip : {
          trigger: 'axis',
          formatter: function(params) {
            if(params.length === 1) {
              return params[0].seriesName === 'P2P'
              ?
              `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#12a5ed;"></span>
                P2P: ${params[0].value}`
              :
              `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:red;"></span>
                HTTP: ${params[0].value}`
            } else if(params.length === 2) {
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#12a5ed;"></span>
                P2P: ${params[0].value}<br />
                <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:red;"></span>
                HTTP: ${params[1].value}`
            }
          },
          textStyle:{
            align:'left'
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              width: 0
            }
          }
        },
        xAxis: {
          type: 'category',
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
          boundaryGap : false,
          axisTick: {
            show: false
          },
          axisLabel : {
            formatter: function(){
              return '';
            }
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: function(value) {
            const max = value.max.toString()
            let yValue = Number(max[0]) + 1
            for (let i = 1; i < max.length; i++) {
              yValue += '0'
            }
            return yValue
          },
          axisLabel:{ formatter:'{value}' },
          axisTick: {
            show: false
          },
        },
        grid: {
          top: '10%',
          bottom: '25%',
          left: 66,
          right: 50
        },
        series: [
          {
            type: 'line',
            name: 'P2P',
            showSymbol: false,
            hoverAnimation: false,
            areaStyle: {
              color: '#12a5ed'
            },
            lineStyle: {
              color: '#12a5ed'
            },
            smooth: true,
            data: this.data.series2,
          },
          {
            type: 'line',
            name: 'HTTP',
            showSymbol: false,
            hoverAnimation: false,
            areaStyle: {
              color: 'red'
            },
            lineStyle: {
              color: 'red'
            },
            smooth: true,
            data: this.data.series1,
          }
        ]
      }
      this.myChart.setOption(options)
    }
  },
  watch: {
    lineData: {
      handler(val, oldVal) {
        this.data = JSON.parse(JSON.stringify(val))
        this.renderChart()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
#myChartWrap {
  height: 300px;
  margin-top: 60px;
}
</style>

